import { client } from '..';
import { BillingInfoParams, BillingInfoResponse, EditIndividualParams } from '../models/individualModels';

export const editIndividualProfile = async ({
  userId,
  firstName,
  lastName,
  thumbnail,
  biography
}: EditIndividualParams) => {
  const url = `/users/${userId}`;

  const body: Partial<EditIndividualParams> = {};
  if (firstName) body.firstName = firstName;
  if (lastName) body.lastName = lastName;
  if (thumbnail) body.thumbnail = thumbnail;
  if (biography) body.biography = biography;

  const { data } = await client.put(url, body);

  return data;
};

export const createBillingInfo = async (body: BillingInfoParams): Promise<BillingInfoResponse> => {
  const { data } = await client.post('/users/billing-info', body);

  return data;
};

export const editBillingInfo = async (body: BillingInfoParams): Promise<BillingInfoResponse> => {
  const { data } = await client.put('/users/billing-info', body);

  return data;
};

export const getBillingInfo = async (): Promise<BillingInfoResponse> => {
  const { data } = await client.get('/users/billing-info');

  return data;
};
